export default "__VITE_ASSET__6e99bc44__"